// extracted by mini-css-extract-plugin
module.exports = {"teamNames":"HeaderTeams_teamNames__3NHF8","guests":"HeaderTeams_guests__XgVAs","owners":"HeaderTeams_owners__1Qkm8","active":"HeaderTeams_active__1rM40"};